"use client";

import * as React from 'react';
import { AuthProvider } from './auth-context';
import { PayPalContextProvider } from './paypal-context';

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <PayPalContextProvider>
        {children}
      </PayPalContextProvider>
    </AuthProvider>
  );
}
